<template >
<div>
    <div @click="_manageExitClicksBehavior()" v-if="show_waiting" id="workspace-favorites-fullscreen" class="waitings-pc-full"> 
        <div @click="_turnOnClosingShield()" id="primary-div"  class="user-workspaces" style="background-color: #f3f4f7; box-shadow: 0px 2px 5px black; border-radius: 2%;">
            <div class="addwaitings-workspace-container-style" ref="addwaitingsWorkspace">
                <header>
                    <input
                    @click="_manageExitClicksBehavior()"
                    type="button" class="material-icons-outlined close-waiting-modal" style="border: none;float: right; margin-right: 8px; cursor: pointer;" value="close">
                    <h3 class="title-favorites">Añadir ticker a cartera</h3>
                    <div class="ticker-name">{{ stock.ticker }}</div>
                </header>

                <div class="cartera-1" v-if="this.user_portfolios.length != 0 && this.portfolio_selected.length != 0">
                        <SelectOutlineWallet
                            id="add-waiting-cartera-element"
                            style="border-radius:20px;"
                            :label_name="select_items[0].label_name"
                            :options="this.user_portfolios"
                            :helper_select_permission="select_items[0].helper_select_permission"
                            :helper_text_select="this.helper_text_select"
                            :default_value="this.portfolio_selected[0].name"
                            :component_class="select_items[0].component_class"
                            @_emit_method_order_select="_changePortfolioSelected"
                         />
                </div>

                <div class="cartera-1">
                        <SelectOutlineWallet
                            id="cartera-element"
                            style="border-radius:20px;"
                            :label_name="select_type[0].label_name"
                            :options="this.instrument_type_options"
                            :helper_select_permission="select_type[0].helper_select_permission"
                            :helper_text_select="this.helper_text_select"
                            :default_value="select_type[0].default_value"
                            :component_class="select_type[0].component_class"
                            @_emit_method_order_select="_changeInstrumentSelected"
                         />
                </div>

                <div>
                    <Button class="button-class-pc" @_emit_method_button="_sendAction" :button_name="button_name" :button_key="button_key" />
                </div>
            </div>
        </div>
    </div>
</div>
    
</template>



<script>
import "vue-swatches/dist/vue-swatches.css";
import Button from "@/components/helpers/Button";
import APICaller from "@/components/codeComponents/APICaller.js";
import inputFavorites from './configs/favorites-workspace.json';
import inputEditFavorites from './configs/edit-favorites-workspace.json';
import { mapGetters } from "vuex";
import SelectOutlineWallet from "@/components/helpers/SelectOutline_wallet.vue";
import SelectWallet from "@/components/stockchart/components/configs/select_waiting.json";
import SelectType from "@/components/stockchart/components/configs/select_type_instrument.json";

export default {
    mixins: [APICaller],
    components: { 
        SelectOutlineWallet,
        Button
    },
    name: 'Workspaces',
    props: {
        stock: { },
        stocks: { type: Array },
        show_waiting: { type: Boolean},
    },

    data: () => ({
        input_favorites : inputFavorites,
        input_edit_favorites : inputEditFavorites,
        workspaces: [],
        isClosingShieldOn: false,
        isCreating: false,
        isDeleting: false,
        isEditing: false,
        createWorkspaceNewName: "",
        editWorkspaceNewName: "",
        currentlyDeleting: {},
        currentlyEditing: {},
        createWorkspaceColor: "#000000",
        editWorkspaceColor: "#000000",

        user_portfolios:[],
        select_items: SelectWallet,
        portfolio_selected:[],
        helper_text_select:"",

        instrument_type_options: [{"name": 'STOCK', "value": 'Stock'},{"name": 'CFD', "value": 'CFD'}],
        select_type: SelectType,

        button_name:"Enviar",
        button_key: "Send",
        active_button: true,

        portfolio: '',
        instrument: '',

        initialized: false,



    }),

    watch: {
        // Update workspace isFavorite property each time a new stock is selected
        stock: {
            handler() {
                if(!this.initialized) {
                    if(this.stock && typeof this.stock === 'object' && Object.keys(this.stock).length != 0 && this.stocks.length != 0) {
                        this._initWorkspaces();
                        this._getPortfolios();
                        this._defaultPortfolio();
                        this._updateViewStockFavoriteWorkspaces();
                    }
                }
                else {
                    this._updateViewStockFavoriteWorkspaces();
                }
            },
            deep: true,
        },
    },

    computed: {
    },

    created() {
    },

    mounted() {
        setTimeout(function(){
            this._initWorkspaces();
            this._getPortfolios();
            this._defaultPortfolio();
        }.bind(this), 100);
    },

    methods: {

        /*
         *   Operations - Creation, edition, deletion, set/unset as favorite for stock
         */

        // #Creation
        // Gets the favorite workspaces from the API and stores them in this.workspaces
        _initWorkspaces: function() {
            let success = response => {
                for (let index = 0; index < response.data.folders.length; index++) {
                        this.workspaces.push({
                            name: response.data.folders[index][0],
                            color: response.data.folders[index][1],
                            isFavorite: false,
                        });
                    }
                this.initialized = true;
            };

            let url = '/api/v1/stock-finder/favorite-folder/list';
            
            const successHandler = new APICaller.SuccessHandler(success);
            const failureHandler = new APICaller.FailureHandler('091', 'Error cargando lista de favoritos.');

            this._getAPICall(url, successHandler, failureHandler);
            
        },    
        // Terminates ongoing edition without saving if there's any, displays creation menu
        _createWorkspacePrepare: function() {
            this._editWorkspaceCancel();
            this.createWorkspaceColor = this._generateRandomHexColor();
            this.isCreating = true;
        },

        _updateViewStockFavoriteWorkspaces: function() {
            for(let workspace in this.workspaces){
                if( this.stock.folder_name.indexOf(this.workspaces[workspace].name) != -1) {
                    this.workspaces[workspace].isFavorite = true;
                }
                else {
                    this.workspaces[workspace].isFavorite = false;
                }
            }
        },

        _getPortfolios: function(){
            let success = (response) => {                
                response.data.forEach(element => {
                this.user_portfolios.push({"name": element.idc, "value": element.name});
            });
            };

            let url = '/api/v1/portfolio/list';

            const successHandler = new APICaller.SuccessHandler(success);
            const failureHandler = new APICaller.FailureHandler('092', 'Error cargando lista de carteras.');

            this._getAPICall(url, successHandler, failureHandler);

        },


        _sendAction: function(){
            let params = new URLSearchParams();
            //params.append('stocks', JSON.stringify([this.stock]));

            params.append('instrument_type', this.instrument);
            params.append('ticker', this.stock.ticker);
            params.append('entry_type', this.stock.tipus_entrada);
            params.append('direction', this.stock.direccio);

            let url = '/api/v1/portfolio/waitings/add/' + this.portfolio;


            let success = () => {
                this.$vueOnToast.pop('success', "Ticker " + this.stock.ticker, "Enviado a correctamente!");
                this.$emit("waiting-added")
                if(this.stock.waitings_portfolio_name === undefined) {
                    this.stock.waitings_portfolio_name = [this.portfolio];
                }
                else {
                    this.stock.waitings_portfolio_name.push(this.portfolio);
                }
                this._manageExitClicksBehavior()
            };

            const successHandler = new APICaller.SuccessHandler(success);
            const failureHandler = new APICaller.FailureHandler('279', 'Error agregando ticker a la cartera.');

            this._postAPICall(url, params, successHandler, failureHandler);

        },

        _defaultPortfolio: function(){
            let success = (response) => {               
                this.portfolio_selected.push({"name": response.data.idc, "value": response.data.name});
            };

            let url = '/api/v1/portfolio-invest-preferences';

            const successHandler = new APICaller.SuccessHandler(success);
            const failureHandler = new APICaller.FailureHandler('093', 'Error cargando preferencias de cartera.');

            this._getAPICall(url, successHandler, failureHandler);
        },

        _changePortfolioSelected: function(value){            
            this.portfolio = value[0];

        },
        _changeInstrumentSelected: function(value){
            this.instrument = value[0];
        },


        // Decides the behavior of a click on a closing triggering position
        // If there's an ongoing operation it will be cancelled
        // If there's not then the window will close
        _manageExitClicksBehavior: function() {
            let that = this;
            if(!this.isEditing && !this.isCreating && !this.isDeleting){
                setTimeout(function() {
                    if (!that.isClosingShieldOn) {
                        that.$emit('_closeWaitingValueWindow');
                    }
                    that.isClosingShieldOn = false;

                }, 10);
            } else {
                setTimeout(function() {
                    if(!that.isClosingShieldOn) {
                        that._cancelOngoingOperations();
                    }
                    that.isClosingShieldOn = false;
                },10);
            }

        },
        

        // Sets a flag necessary for window closing behaviour
        _turnOnClosingShield: function() {
            this.isClosingShieldOn = true;
        },


        /*
         *   Misc
         */

        //Generates a random color for the swatch
        _generateRandomHexColor: function() {
            let randomColor = Math.floor(Math.random()*16777215).toString(16);
            return "#" + randomColor;
        },
  },
}
</script>


<style lang="scss">
    #workspace-favorites-fullscreen.waitings-pc-full {
        position: fixed;
        top: 0px;
        background: rgba(0, 0, 0, 0.7);
        width: 100%;
        height: 100%;
        z-index: 9999;
        cursor: pointer;
        left: 0px;
    }
    .workspace-name-container{
        text-align:center; 
        margin-top:15px;
    }
    .addwaitings-workspace-container-style{
        position: fixed;
        min-height: 400px;
        width: 320px;
        background: var(--color-surface);
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border: 1px solid var(--color-outline);
    }

    .user-workspaces {
        width: 300px;
        z-index: 999999;
        display: block !important;
        color: black;
        text-align: left;
        position: absolute;
        text-decoration: none;
        background-color: #f3f4f7;
        border-radius: 5px;       
    }

    .title-favorites{
        margin-top: 10px; 
        margin-left: 20px;
        font-size: 15px;
        color: var(--color-text-primary);
    }

    .add-button-container{
        text-align: center;
        position:relative;
    }

    .close {
        position: absolute;
        right: 4px;
        cursor:pointer;
    }

    #workspace-select-favorite-icon {
        display: inline-block;
    }
    .remove-text-container{
        text-align:center;
        font-size:13px;
        margin-top:50px;
    }
    .remove-star-container{
        text-align:center;
        margin-top:25px;
        margin-bottom:25px;
    }
    .remove-button-container input{
        width:140px;
        height:35px;
        color:white;
        font-weight:bold;
        background-color:#00aedd;
        border-radius:30px;
        border-color:transparent;
       
    }
    .cancel-button-container input{
        border:none;
        color:#2e81a5;
        font-weight:bold;
        margin-top:15px;

    }

    .remove-star-containter{
        text-align: center;
        margin-bottom: 20px;
    }

    .cartera-1{
        margin-top: 30px;
        width: 70%;
        margin-left: 47px;
    }

    .button-class-pc{
        margin-left: 40px;
        margin-top: 35px;
    }

    .ticker-name {
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        margin: 10px 0;
        color: var(--color-text-secondary);
    }

    .close-waiting-modal {
        color: var(--color-text-primary);
        background-color: var(--color-surface);
    }
</style>